var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.container},[_c('a',{staticClass:"block w-full h-full",attrs:{"href":_vm.banner.url,"target":"_target"}},[_c('el-image',{staticClass:"w-full h-full",attrs:{"fit":"cover","src":_vm.banner.path}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }